import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Team members (JobUserDto) assigned to a job. */
export function useJobTeam(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.jobs.team(jobId ?? -1),
    queryFn: ({ signal }) =>
      jobApiClient.getTeam(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 30_000,
    meta: { errorContext: 'job team' },
  });
}

export function useJobTeamByOffice(officeName: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.jobs.teamByOffice(officeName ?? ''),
    queryFn: ({ signal }) =>
      jobApiClient.getTeamByOffice(officeName!, toCancelToken(signal)),
    enabled: !!officeName,
    staleTime: 30_000,
    meta: { errorContext: 'office team' },
  });
}
